/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type appEconomic_viewer$ref = any;
export type appEconomic_QueryVariables = {||};
export type appEconomic_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: appEconomic_viewer$ref,
  |}
|};
export type appEconomic_Query = {|
  variables: appEconomic_QueryVariables,
  response: appEconomic_QueryResponse,
|};
*/


/*
query appEconomic_Query {
  viewer {
    actualPersonId
    component(name: "app_economic")
    ...appEconomic_viewer
    id
  }
}

fragment appEconomic_viewer on Viewer {
  id
  company {
    id
    economicEnabled
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "app_economic"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"app_economic\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appEconomic_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appEconomic_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appEconomic_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "economicEnabled",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "appEconomic_Query",
    "operationKind": "query",
    "text": "query appEconomic_Query {\n  viewer {\n    actualPersonId\n    component(name: \"app_economic\")\n    ...appEconomic_viewer\n    id\n  }\n}\n\nfragment appEconomic_viewer on Viewer {\n  id\n  company {\n    id\n    economicEnabled\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8f76986a72f248918f403e1d543556e8';

module.exports = node;
